import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static values = {
    options: Object,
    placeholder: String,
    allowEmpty: Boolean,
    preserveOrder: Boolean
  }

  connect() {
    const defaultOptions = {
      plugins: ['clear_button'],
      placeholder: this.placeholderValue || 'Seleziona...',
      allowEmptyOption: this.hasAllowEmptyValue ? this.allowEmptyValue : true,
      maxOptions: null,
      create: false,
      hidePlaceholder: true,
      hideSelected: false,
      searchField: ['text'],
      // Ordina alfabeticamente solo se non si vuole preservare l'ordine originale
      ...(this.preserveOrderValue ? {} : {
        sortField: {
          field: "text",
          direction: "asc"
        }
      }),
      render: {
        no_results: () => {
          return '<div class="no-results">Nessun risultato trovato</div>';
        }
      },
      onInitialize: function() {
        this.on('focus', () => {
          if (this.getValue() === '') {
            this.inputState()
          }
        })
      }
    }

    const options = this.hasOptionsValue
      ? { ...defaultOptions, ...this.optionsValue }
      : defaultOptions

    this.select = new TomSelect(this.element, options)
  }

  disconnect() {
    if (this.select) {
      this.select.destroy()
    }
  }
}
